import $apiJSON from '../http/apiJSON'

// Visitor Statistics API Service

/**
 * Получить статистику посетителей сайта
 * @returns {Promise} {online_count: number, total_visits: number}
 */
export async function getVisitorStats() {
  const response = await $apiJSON.get('stats/visitors/')
  return response.data
}
